import React from 'react'
import {useLocation} from 'react-router-dom'
import {Signboard} from '../../../DTO/SignboardDTO'
import {MBMemberError} from '../../../Common/MBMemberError'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {SendConfirmMailContent} from '../../Components/CompleteContentBlocks/SendConfirmMailContent'
import {useTranslation} from 'react-i18next'

type LocationState = {
  signboard: Signboard
}

function MembersInvitationCompletePage(): JSX.Element {
  const {t} = useTranslation('member')
  const location = useLocation<LocationState>()
  const locationState: LocationState = location.state

  function isInvalidLocationState(locationState: LocationState): boolean {
    if (!locationState) {
      return true
    }
    if (!locationState.signboard) {
      return true
    }
    if (!locationState.signboard.signupName || !locationState.signboard.logoImgUrl) {
      return true
    }
    return false
  }

  if (isInvalidLocationState(location.state)) {
    throw new MBMemberError('InvalidOperation')
  }

  return (
    <MembersPageTemplate>
      <PageTitle>{`${locationState.signboard.signupName} 新規登録URL発行`}</PageTitle>

      <SendConfirmMailContent
        title={'本人確認メール送信完了'}
        topMessage={'ご入力いただいたメールアドレスに本人確認メールを送信しました。\n' +
          '現在メールによる本人確認待ちです。\n' +
          '届いたメールに記載されているURLより新規登録を続けてください。\n' +
          'メールに記載されているURLの有効期限は3時間となっています。'}
        note={[
          'ご登録手続きは、まだ完了していませんのでご注意ください。',
          t('新規登録URL発行.注記 メール受信設定'),
        ]}
        logoImgUrl={locationState.signboard.logoImgUrl}
      />
    </MembersPageTemplate>
  )
}

export default MembersInvitationCompletePage
